<template>
  <button-base :borderRadius="'sm1'" :class="componentClasses" :type="'outline'" @click="clicked()">
    <div class="gc-button-secondary-backward__left-section">
      <icon-backward size="md1"></icon-backward>
    </div>

    <div class="gc-button-secondary-backward__right-section">
      <div class="gc-button-secondary-backward__text-section">
        <text-content :class="textClass" :line-height="'multi'" :size="'sm4'" :weight="'extra-bold'"> {{ text }}</text-content>
        <text-content :class="subTextClass" :line-height="'multi'" :size="'sm1'" v-if="hasSubText"> {{ subText }}</text-content>
      </div>
    </div>

  </button-base>
</template>

<script>

import TextContent from '../../root/TextContent'
import ButtonBase from '../../root/ButtonBase'
import IconBackward from '../../root/icons/IconBackward'

export default {
  name: 'ButtonSecondaryBackward',
  components: {
    ButtonBase,
    TextContent,
    IconBackward
  },
  props: {
    /**
     * The main text of the button
     */
    text: {
      default: ''
    },
    /**
     * The sub text of the button
     */
    subText: {
      default: ''
    },
    /**
     * The disabled state of the button
     */
    disabled: {
      default: false
    }
  },
  computed: {
    hasSubText: function () {
      return this.subText.replace(/\s/g, '') !== ''
    },
    hasIcon () {
      return !!this.$slots.default
    },
    textClass: function () {
      return {
        'gc-button-secondary-backward__text': true,
        'gc-button-secondary-backward__text--with-sub-text': this.hasSubText
      }
    },
    subTextClass: function () {
      return {
        'gc-button-secondary-backward__sub-text': this.hasSubText
      }
    },
    componentClasses: function () {
      return {
        'gc-button-secondary-backward': true,
        'gc-button-secondary-backward--with-sub-text': this.hasSubText,
        'gc-button-secondary-backward--disabled': this.disabled
      }
    }
  },
  methods: {
    /**
     * function to emit the click event
     */
    clicked () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style scoped></style>
